<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>

        <div class="ticket">
            <rwidget-isic-card-activation-aside></rwidget-isic-card-activation-aside>
            <rwidget-isic-card-activation></rwidget-isic-card-activation>
        </div>
    </ridango-page-content-wrapper>
</div>
